function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#29C5F6",
  d: "M125.8 1H4.2A3.2 3.2 0 001 4.2v121.6a3.2 3.2 0 003.2 3.2h121.6a3.2 3.2 0 003.2-3.2V4.2a3.2 3.2 0 00-3.2-3.2z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M90.247 48.26c4.567-2.982 4.971-7.074 4.971-7.074-1.478 2.038-8.061 3.125-8.061 3.125-5.643-6.659-14.107-3.125-14.107-3.125-9.94 3.534-8.463 15.083-8.463 15.083-17.33-.271-26.736-13.588-26.736-13.588-5.173 10.87 3.562 17.461 3.562 17.461-1.949.204-5.441-1.359-5.441-1.359-.134 9.989 10.21 13.524 10.21 13.524-.94.135-5.375.135-5.375.135 2.286 8.153 11.957 8.97 11.957 8.97-9.403 7.067-18.808 5.844-18.808 5.844 9.27 7.066 18.455 6.321 24.72 5.437C74.074 90.515 82.32 79.237 82.32 79.237c10.882-13.997 7.255-25.821 9.002-26.5.028-.011.058-.024.088-.039 1.8-.819 5.957-6.077 5.957-6.077-2.955 1.63-7.12 1.639-7.12 1.639z"
});

function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 130 130"
  }, props), _ref, _ref2);
}

export default SvgTwitter;